//import React from 'react';
import { connect } from 'react-redux';
import Editor from '../components/Editor';
import { getDateTime } from '../helper';
import { onBackClick, onNextClick, SAVE_RESUME, saveResume, nuteralizeNextClick, nuteralizeBackClick, PREVIEW_RESUME, deleteSection, onSkipClick, setVersion, setSectionCompleteness, resumeReview } from '../services/actions/actions';

export const mapStateToProps = (state, ownProps) => {
    // const { resume, available_steps } = state;
    return { ...state }
};

export const mapDispatchToProps = dispatch => {
    return { handlers:{
        resumeReview: (res = null, saveit = true) => dispatch(resumeReview(res, saveit)),
        onNextClick: () => dispatch(onNextClick()),
        onBackClick: () => dispatch(onBackClick()),
        onSkipClick: () => dispatch(onSkipClick()),
        onsaveResume: () => dispatch(saveResume({ modified_date: getDateTime() }, PREVIEW_RESUME, true)),
        updateResumePreview: (data,saveit = false) => dispatch(saveResume( data , PREVIEW_RESUME,saveit)),
        nuteralizeNextClick: (data,saveit=false,nextModule='') => dispatch(nuteralizeNextClick(data,saveit,nextModule)),
        nuteralizeBackClick: data => dispatch(nuteralizeBackClick(data)),
        deleteSection: data => dispatch(deleteSection(data)),
        onValueChange: data => dispatch(setVersion(data)),
        hasError: section_data => section_data?.summary.aggregate_deductible_points > 0 
         
         
        }
    }
};

const EditorContainer = connect(mapStateToProps, mapDispatchToProps)(Editor);
export default EditorContainer;
